import { isTourV2ExperienceItem } from 'lib/checkout/checkoutUtils'
import { createSelector } from 'reselect'
import { reselectShallowEqual } from 'lib/selector/selectorUtils'

export const getTourV2ExperienceItems = createSelector(
  (state: App.State) => state.checkout.cart.items,
  (items): Array<App.Checkout.TourV2ExperienceItem> =>
    items.filter(isTourV2ExperienceItem),
  reselectShallowEqual,
)
